import { JSX, useMemo } from "react";
import {
  StoreSection,
  StoreBrand,
  StoreReview,
} from "@/app/lib/features/store/store.types";
import { Product } from "@/app/lib/features/product/product.types";
import StoreBrandsSection from "@/app/components/common/store/StoreBrandsSection";
import StoreProductsSection from "@/app/components/common/store/StoreProductsSection";
import StoreReviewsSection from "@/app/components/common/store/StoreReviewsSection";

interface StoreSectionComponent {
  slug: string;
  component: JSX.Element;
}

export const useStoreSectionBuilder = (
  sections: StoreSection[],
  sellerSlug?: string,
): StoreSectionComponent[] => {
  return useMemo(() => {
    return sections
      .filter((section) => section.items.length > 0)
      .map((section) => {
        let component: JSX.Element;

        const viewAllUrl = sellerSlug && section.view_all_url_web
          ? `/magaza/${sellerSlug}${section.view_all_url_web}`
          : section.view_all_url;

        switch (section.type) {
          case "brand_list":
            component = (
              <StoreBrandsSection
                key={section.slug}
                brands={section.items as StoreBrand[]}
              />
            );
            break;

          case "product_grid":
            component = (
              <StoreProductsSection
                key={section.slug}
                title={section.title}
                products={section.items as Product[]}
                viewAllUrl={viewAllUrl}
              />
            );
            break;

          case "review_list":
            component = (
              <StoreReviewsSection
                key={section.slug}
                title={section.title}
                reviews={section.items as StoreReview[]}
              />
            );
            break;

          default:
            return null;
        }

        return { slug: section.slug, component };
      })
      .filter(Boolean) as StoreSectionComponent[];
  }, [sections]);
};
